import { Modal } from "@mantine/core";
import { ReactNode } from "react";

interface FullScreenModalProps {
  opened: boolean;
  closeOnEscape?: boolean;
  title?: string;
  children: ReactNode;
  zIndex?: number;
  onClose: () => void;
}

export const FullScreenModal = ({
  opened,
  title = "Preview",
  children,
  closeOnEscape = true,
  zIndex = 2001,
  onClose,
}: FullScreenModalProps) => (
  <Modal
    opened={opened}
    onClose={onClose}
    closeOnEscape={closeOnEscape}
    fullScreen
    title={title}
    size="xl"
    centered
    withinPortal
    zIndex={zIndex}
  >
    {children}
  </Modal>
);
